// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3DBu3","row":"ProcedureTreatmentSummary_row__1Selr"};